var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{attrs:{"colspan":"8"}},_vm._l((_vm.headers),function(header,index){return _c('span',{key:index,staticClass:"group-header"},[_vm._v(_vm._s(header))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }